// @ts-ignore-next-line
const saveDataEnabled: boolean = ('connection' in navigator) && ('saveData' in navigator.connection) && navigator.connection.saveData;

export function useSaveData(): boolean {
    return saveDataEnabled;
}
